// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1W7L1","header":"ClearentDisclaimer_header__2UWfY","inner":"ClearentDisclaimer_inner__BeBKf"};